import { useEffect, useReducer, useRef, useState } from 'react';

export function useMinSplash(active: boolean, minMs = 1000): boolean {
  const [hideAt, setHideAt] = useState<number | null>(null);
  const [, force] = useReducer((x: number) => x + 1, 0);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (active) {
      const now = Date.now();
      let nextHideAtComputed = 0;
      setHideAt((prev) => {
        const next = Math.max(prev ?? 0, now + minMs);
        nextHideAtComputed = next;
        return next;
      });
      if (timerRef.current) {
        globalThis.clearTimeout(timerRef.current);
      }
      const remaining = (nextHideAtComputed || now + minMs) - now;
      timerRef.current = globalThis.setTimeout(() => {
        timerRef.current = null;
        force();
      }, remaining);
    }
    return () => {};
  }, [active, minMs]);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        globalThis.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const now = Date.now();
  const stillBeforeMin = hideAt !== null && now < hideAt;
  return active || stillBeforeMin;
}
